import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import Link from "@insightfulscience/atomic-react/Link";
import Picture, { sourceItemPropTypes } from "@insightfulscience/atomic-react/Picture";
import { Col } from "../Grid";
import ImageCaption from "../Image/Caption";
import Image from "../Image";
import { classes } from "../utils/classes";

const FImage = ({
	caption,
	imageCaptionClassName,
	isImageFrame,
	imageClassName,
	shadow,
	src,
	srcList = [],
	alt,
	isBaseUrl,
}) => {
	return (
		<ImageCaption caption={caption} className={imageCaptionClassName}>
			{srcList.length ? (
				<Picture
					src={src}
					srcList={srcList}
					className={classes(isImageFrame && "feature__image--frame", imageClassName)}
					shadow={shadow}
					isBaseUrl={isBaseUrl}
				/>
			) : null}
			{src && !srcList.length ? (
				<Image
					className={classes(isImageFrame && "feature__image--frame", imageClassName)}
					shadow={shadow}
					src={src}
					alt={alt}
					isBaseUrl={isBaseUrl}
				/>
			) : null}
		</ImageCaption>
	);
};

FImage.propTypes = {
	shadow: bool,
	src: string.isRequired,
	srcList: arrayOf(shape(sourceItemPropTypes)),
	alt: string,
	caption: string,
	isImageFrame: bool,
	imageCaptionClassName: string,
	imageClassName: string,
	isBaseUrl: bool,
};

const FeatureImage = ({
	shadow = false,
	src,
	srcList = [],
	alt = "",
	caption = "",
	sm = 12,
	md = 6,
	className = "",
	isImageFrame = false,
	imageCaptionClassName = "",
	imageClassName = "",
	isBaseUrl,
	href = "",
	...props
}) => (
	<Col sm={sm} md={md} className={classes("feature__image", className)} {...props}>
		<div className="feature__image--indent">
			{href ? (
				<Link href={href}>
					<FImage
						caption={caption}
						imageCaptionClassName={imageCaptionClassName}
						isImageFrame={isImageFrame}
						imageClassName={imageClassName}
						shadow={shadow}
						src={src}
						srcList={srcList}
						alt={alt}
						isBaseUrl={isBaseUrl}
					/>
				</Link>
			) : (
				<FImage
					caption={caption}
					imageCaptionClassName={imageCaptionClassName}
					isImageFrame={isImageFrame}
					imageClassName={imageClassName}
					shadow={shadow}
					src={src}
					srcList={srcList}
					alt={alt}
					isBaseUrl={isBaseUrl}
				/>
			)}
		</div>
	</Col>
);

FeatureImage.propTypes = {
	shadow: bool,
	src: string.isRequired,
	srcList: arrayOf(shape(sourceItemPropTypes)),
	alt: string,
	caption: string,
	sm: Col.propTypes.sm,
	md: Col.propTypes.md,
	isImageFrame: bool,
	imageCaptionClassName: string,
	imageClassName: string,
	isBaseUrl: bool,
	className: string,
	href: string,
};

export default FeatureImage;
